import { useClient, useItems } from "@adamlip/okeoke.client"
import ListItemShell from "./ListItemShell"
import { UserContext } from "contexts/UserContext"
import useStorage from "hooks/useStorage"
import moment from "moment"
import { useContext, useEffect, useState } from "react"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function CategoryItems({
  selectedCategory,
  className,
  readOnly,
}) {
  const { getName } = useClient()
  const { appParams } = useContext(AppParamsContext)

  const { categories, assembledItems } = useItems()

  const { userData } = useContext(UserContext)
  const [bannedItems, setBannedItems] = useState([])
  const { getSV } = useStorage()

  useEffect(() => {
    if (categories?.[selectedCategory]) {
      setBannedItems(
        (categories?.[selectedCategory]?.items || [])
          .filter((item) => filterFunction(item.uuid))
          .map((item) => item.uuid)
      )
    }
    //eslint-disable-next-line
  }, [selectedCategory, categories])

  const filterFunction = (itemUUID) => {
    if (itemUUID == null) return false
    let years = moment().diff(userData?.birthDate, "years")
    let banned = false
    if (!getSV("anoLoginUUID")) {
      if (years < 18) {
        const alcoholicCategories = [23, 24, 25, 26, 27, 28, 41]
        for (let size of assembledItems?.[itemUUID]?.sizes || []) {
          if (alcoholicCategories.includes(size?.ntakCategoryID || 0))
            banned = true
        }
      }
    }
    return banned
  }
  const categoryNameStyle = appParams?.items?.categoryStyle?.categoryName
  const categoryDescStyle = appParams?.items?.categoryStyle?.categoryDesc
  const renderExtraClass = (type, isDescription) => {
    let extraClass = ""
    extraClass += ` ${type?.fontSize || (isDescription ? "text-xs" : "text-lg")
      } ${type?.fontWeight || (isDescription ? "font-light" : "font-bold")}`
    if (type?.uppercase) {
      extraClass += ` !uppercase `
    }
    if (type?.visible === false) {
      extraClass += " hidden"
    }
    return extraClass
  }

  if (categories?.[selectedCategory] == null) return null

  return (
    <div
      name={`orderItemList-byCategory_${selectedCategory}`}
      id={`orderItemList-byCategory_${selectedCategory}`}
      className={`type2 orderItemList-category hidden-content appear ${className}`}
    >
      <div className="category-header">
        <div
          style={{
            color:
              categoryNameStyle?.fontColor || "var(--order-items-text-color)",
          }}
          className={` mt-[0.25em] text-center   ${renderExtraClass(
            categoryNameStyle,
            false
          )}`}
        >
          {getName(categories?.[selectedCategory]?.name)}
        </div>
        <div
          style={{
            color:
              categoryDescStyle?.fontColor || "var(--order-items-text-color)",
          }}
          className={` opacity-60 ${renderExtraClass(categoryDescStyle, true)}`}
        >
          {getName(categories?.[selectedCategory]?.description)}
        </div>
      </div>
      <div className="orderItemList-category-items flex md:flex-row md:gap-4 md:flex-wrap flex-col">
        {(categories?.[selectedCategory]?.items || [])
          .filter((item) => assembledItems?.[item?.uuid]?.visibleSizes > 0)
          .map((item) => (
            <ListItemShell
              key={item.uuid}
              readOnly={readOnly}
              itemUUID={item?.uuid}
              bannedItems={bannedItems}
            />
          ))}
      </div>
    </div>
  )
}
